import { LEARNING_STEPS, LearningProgressService } from './LearningProgressService';

const KEY_PREFIX = 'placement_done_';

// Self-assessment (no per-language content required): 3 questions, each
// scored 0-3, mapped to a starting index in LEARNING_STEPS. This is a
// coarse placement, not a knowledge quiz — it exists so a returning learner
// doesn't have to grind through steps they've already outgrown.
export const PLACEMENT_QUESTIONS = [
  {
    id: 'vocab',
    labelKey: 'placement.q1',
    optionKeys: ['placement.q1o0', 'placement.q1o1', 'placement.q1o2', 'placement.q1o3'],
  },
  {
    id: 'conversation',
    labelKey: 'placement.q2',
    optionKeys: ['placement.q2o0', 'placement.q2o1', 'placement.q2o2', 'placement.q2o3'],
  },
  {
    id: 'comprehension',
    labelKey: 'placement.q3',
    optionKeys: ['placement.q3o0', 'placement.q3o1', 'placement.q3o2', 'placement.q3o3'],
  },
];

function stepIndexForScore(score) {
  if (score <= 1) return 0;
  if (score <= 3) return 2;
  if (score <= 5) return 3;
  if (score <= 7) return 5;
  return 8;
}

export const PlacementTestService = {
  stepIndexForScore,

  /**
   * Marks every learning step before the assessed level as complete, so the
   * path reflects existing knowledge instead of starting from zero.
   * LearningProgressService.record() internally clamps to each step's
   * target, so passing an oversized amount is a safe way to mark "done".
   */
  applyResult(langPair, score) {
    const placedIndex = stepIndexForScore(score);
    for (let i = 0; i < placedIndex; i++) {
      LearningProgressService.record(langPair, LEARNING_STEPS[i], 999);
    }
    this.markCompleted(langPair);
    return placedIndex;
  },

  isCompleted(langPair) {
    return localStorage.getItem(KEY_PREFIX + langPair) === '1';
  },

  markCompleted(langPair) {
    localStorage.setItem(KEY_PREFIX + langPair, '1');
  },
};
